import React, { useContext, useState } from 'react';
import { MDForm } from '../../metadata/MDForm';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { ModelContext } from '../../metadata/ModelSource';
import { DeclaredComponent } from '../../DynamicComponent';
import {DownOutlined, RightOutlined} from "@ant-design/icons";
import { Collapse } from 'antd';

const { Panel } = Collapse;

export function PropertyListForm({ forms, lineCd, formTitle }) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);
  const [activeKey2, setActiveKey2] = useState('0');
  const form = forms['Homeowners'];

  const lineProductSetupContext =
    productSetup.productSubTypes.productSubType[0].productLine[0]
      .productRiskTypes.productRiskType[0];

  return (
    <div>
      <Collapse
        expandIcon={(props) => {
          const { panelKey, isActive } = props;
          const iconClickAction = () => {
            if (activeKey2 === panelKey) {
              return setActiveKey2('');
            }
            setActiveKey2(panelKey);
          }
          return isActive ? <DownOutlined onClick={iconClickAction} /> : <RightOutlined onClick={iconClickAction} />;
        }}
        bordered={false}
        activeKey={activeKey2}
        defaultActiveKey={'0'}
        accordion
        style={{borderBottom: '0px'}}
      >
        <Panel header={formTitle}  className='property-list-form-header'>
          <MDForm
            prefix={`lines{lineCd:${lineCd}}.risks[0]`}
            model={applicationModel}
            productSetupContext={lineProductSetupContext}
            presentationMetadata={form}
          >
            <DeclaredComponent declaration={form} />
          </MDForm>
        </Panel>
      </Collapse>
    </div>
  );
}
